import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Button,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import axios from "axios";
import envConfig from "../../../bin/env.config";

import { useSelector } from "react-redux";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    color: theme.palette.text.secondary,
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  fieldLast: {
    marginBottom: 0,
  },
}));

const initState = {
  id: null,
  name: "",
  description: "",
  key_words: "",
  brand_name: "",
  type: "",
  category: "",
  sub_category: "",
};

export default function DialogEdit({ open, onClose, product, project_id, reloadData }) {
  const classes = useStyles();
  const token = useSelector((state) => state.session.token);
  const [inputState, setInputState] = useState(initState);
  const [serverUpdating, setServerUpdating] = useState(false);

  useEffect(() => {
    if (open) {
      setInputState(product ? { ...initState, ...product } : { ...initState });
    }
  }, [product, open]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSave = () => {
    if (!inputState.name?.trim()) return;
    setServerUpdating(true);
  };

  useEffect(() => {
    const serverUpdate = async () => {
      const putData = {
        ...inputState,
        project_id,
      };
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/update-product`;
      await axios.post(url, putData, {
        headers: {
          Authorization: JSON.stringify(token),
        },
      });
      setServerUpdating(false);
      setInputState(initState);
      reloadData();
      onClose();
    };
    if (serverUpdating) {
      serverUpdate();
    }
  }, [serverUpdating]);

  const isAddMode = !product;
  const isSaveDisabled = serverUpdating || !inputState.name?.trim();

  return (
    <Dialog
      open={open}
      onClose={serverUpdating ? undefined : onClose}
      TransitionComponent={Transition}
      aria-labelledby="product-edit-dialog"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="product-edit-dialog">
        {isAddMode ? "Add Product" : `Edit — ${product.name}`}
      </DialogTitle>
      <DialogContent dividers>
        <div className={classes.section}>
          <Typography className={classes.sectionTitle}>Basic information</Typography>
          <TextField
            autoFocus
            required
            label="Full product name"
            name="name"
            fullWidth
            className={classes.field}
            onChange={handleChange}
            value={inputState.name || ""}
            disabled={serverUpdating}
          />
          <TextField
            label="Description"
            name="description"
            multiline
            rows={4}
            fullWidth
            className={classes.fieldLast}
            onChange={handleChange}
            value={inputState.description || ""}
            disabled={serverUpdating}
            placeholder="Optional notes or details about this product"
          />
        </div>

        <div className={classes.section}>
          <Typography className={classes.sectionTitle}>Classification</Typography>
          <TextField
            label="Type"
            name="type"
            fullWidth
            className={classes.field}
            onChange={handleChange}
            value={inputState.type || ""}
            disabled={serverUpdating}
            placeholder="e.g. Food, Drink, Other"
          />
          <TextField
            label="Category"
            name="category"
            fullWidth
            className={classes.field}
            onChange={handleChange}
            value={inputState.category || ""}
            disabled={serverUpdating}
            placeholder="e.g. Bakery, Meat, Dairy"
          />
          <TextField
            label="Sub category"
            name="sub_category"
            fullWidth
            className={classes.fieldLast}
            onChange={handleChange}
            value={inputState.sub_category || ""}
            disabled={serverUpdating}
            placeholder="e.g. Bread/White Bread, Bread/Whole Wheat Bread"
          />
        </div>

        <div className={classes.section}>
          <Typography className={classes.sectionTitle}>Additional details</Typography>
          <TextField
            label="Key words"
            name="key_words"
            fullWidth
            className={classes.field}
            onChange={handleChange}
            value={inputState.key_words || ""}
            disabled={serverUpdating}
          />
          <TextField
            label="Brand name"
            name="brand_name"
            fullWidth
            className={classes.fieldLast}
            onChange={handleChange}
            value={inputState.brand_name || ""}
            disabled={serverUpdating}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={serverUpdating}>
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={onSave}
          disabled={isSaveDisabled}
          startIcon={serverUpdating ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {serverUpdating ? "Saving…" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
